import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import ExportStatusDialog from 'scoreboard/components/export/export-status-dialog'
import i18n from 'scoreboard/components/i18n'
import Xhr from 'scoreboard/components/xhr'
import SingleFormfieldDialog from 'scoreboard/components/single-formfield-dialog'
import AdminPanels from 'scoreboard/admin/admin-panels'
import RollupTree from './rollup-tree'
import { urlRoot } from './rollup-tree'
import DraggableList from 'draggable-list'
import SelectKeySetForm from './select-key-set-form'
import UploadDatasetTree from './upload-rollup-tree'
import adminConnectionsRow from './admin-manage-rollup-trees-row.hbs'
import actionsTemplate from './admin-manage-rollup-trees-actions.hbs'

/**
 * The dialog that is shown when a user clicks the `Manage Rollup Trees` button
 * on Admin -> Dataset Rollup Trees.
 *
 * Add/Edit/Upload here are entire tree (roots), not individual tree nodes.
 * Those are managed using DatasetsTreeEditorMenu.
 */
const AdminManageRollupTreesPanel = AdminPanels.extend({

	className: 'admin-manage-dataset-trees',

	Model: RollupTree,

	rowTemplate: adminConnectionsRow,
	titleDescKeyPrefix: 'datasets.trees',
	labelProperty: 'treeLabel',

	events: _.extend({}, AdminPanels.prototype.events, {
		'click .add': 'onClickAdd',
		'click .upload': 'onClickUpload',
		'click .edit': 'onClickEdit',
		'click .main-actions .download': 'onClickDownload',
		'click .main-actions .replace': 'onClickReplace'
		// delete is handled by AdminPanels
	}),

	initialize: function(options) {
		AdminPanels.prototype.initialize.apply(this, arguments)
		Backbone.on('add:dataset-tree', this._onAdd.bind(this))
		Backbone.on('edit:dataset-tree', this._onEdit.bind(this))
	},

	render: function() {
		AdminPanels.prototype.render.apply(this, arguments)
		this.renderPanel()
		return this
	},

	renderPanel: function(type) {
		let panel = AdminPanels.prototype.renderPanel.apply(this, arguments)
		this.renderPanelActions(panel)
		this.renderList(panel)
		return panel
	},

	renderPanelActions(panel) {
		panel.find('.right-buttons').prepend(actionsTemplate())
		// The panel now has > 1 covert button so they should both be using just icons w/tooltips
		panel.find('.edit-item .add')
			.removeClass('button-covert-labeled')
			.addClass('button-covert')
			.data('action', i18n.get('common.add2', 'datasets.dataType.rollupTree'))
			.find('.label').remove()
	},

	renderList(panel) {
		let draggableList = new DraggableList(panel.find('ul.list')[0])
		draggableList.on('move', this.reorder.bind(this))
		this.draggableLists.push(draggableList)
		panel.addClass('has-draggable-list')
	},

	rerenderItem(item) {
		AdminPanels.prototype.rerenderItem.apply(this, arguments)
		// After an item is re-rendered, we need to recreate the draggable list to restore
		// draggability of the list item which was just swapped out in the DOM #42771.
		this.renderList(this.$('.panel'))
	},

	onClickAdd: function() {
		appDisplay.dialog(new SingleFormfieldDialog({
			model: new RollupTree(),
			heading: i18n.get('common.add2', 'datasets.dataType.rollupTree'),
			fieldLabel: 'common.name',
			fieldName: this.labelProperty
		}))
	},

	onClickUpload: function() {
		const form = new UploadDatasetTree({model: {}})
		form.on('done', model => {
			Backbone.trigger('add:dataset-tree', model)
		})
		appDisplay.dialog(form)
	},

	onClickEdit: function(e) {
		const tree = this._selectedTree(e)
		appDisplay.dialog(new SingleFormfieldDialog({
			model: new RollupTree(tree),
			heading: i18n.get('common.edit2', 'datasets.dataType.rollupTree'),
			fieldLabel: 'common.name',
			fieldName: this.labelProperty
		}))
	},

	onClickReplace: function(e) {
		const tree = this._selectedTree(e)
		appDisplay.dialog($.get(urlRoot + `/${tree.id}`), model => {
			// model is a tree model
			const form = new UploadDatasetTree({ model })
			form.on('done', model => this.trigger('replace', model))
			return form
		})
	},

	onClickDownload: function (e) {
		const tree = this._selectedTree(e)
		appDisplay.dialog($.get(urlRoot + `/${tree.id}`), tree => {
			const selectKeySetForm = new SelectKeySetForm(tree)
			selectKeySetForm.on('done', selectedKeySet => {
				this._downloadFile(tree, selectedKeySet.keySetId)
			})
			return selectKeySetForm
		})
	},

	_downloadFile: function (tree, keySetId) {
		const statusDialog = new ExportStatusDialog({
			heading: i18n.get('datasets.trees.keys.downloadJson.preparing')
		})
		appDisplay.dialog(statusDialog)
		let filename = tree.label + '.json'
		new Xhr().download({
			url: urlRoot + `/${tree.id}/key-sets/${keySetId}/download-json`,
			filename,
			responseType: 'json',
			done: () => {
				statusDialog.trigger('done')
			}
		})
	},

	_selectedTree: function(e) {
		const id = this._itemId(e)
		return _.find(this.collection, {id})
	}
})

export default AdminManageRollupTreesPanel

AdminManageRollupTreesPanel.__filename__ = 'admin/datasets/admin-manage-rollup-trees-panel.js'
